module.exports = __webpack_public_path__ + "static/pic8-7a71000040b46869a8238e678536e0a2.jpg";